<template>
    <b-overlay
        class="h-100 position-relative"
        :show="status === 'loading' && !editMode"
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4>
                    {{ $t('org.dashboard.Account State') }}
                </h4>
            </div>
        </div>
        <div
            class="card-body"
        >
            <div class="d-flex justify-content-center">
                <b-row class="centered-content-statistics">
                    <b-col
                        v-for="(item, index) in statistics" :key="index"
                    >
                        <div
                            class="d-flex pt-1 pb-50"
                        >
                        <b-avatar
                                size="44"
                                :variant="item.variant"
                                :class="needResponsiveStyle ? 'd-none' : ''"
                            >
                                <component :is="item.component" />
                            </b-avatar>
                            <div
                                class="d-flex flex-column justify-content-between ml-1"
                            >
                                <span
                                    class="font-medium-3"
                                    :class="needResponsiveStyle ? `text-${item.variant.split('-')[1]}` : ''"
                                >
                                    {{ item.num }}
                                </span>
                                <small
                                    class="font-small-2 card-grey-95"
                                >
                                    {{ item.item }}
                                </small>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import { getCurrentInstance, computed, watch } from '@vue/composition-api'
import useDashboard from '@/composables/useDashboard'
import useDashboardRender from '@/composables/useDashboardRender'
const SvgStatisticsGroupIcon = () => import('@/assets/images/icons/statistics_group.svg')
const SvgStatisticsProductsIcon = () => import('@/assets/images/icons/statistics_products.svg')
const SvgStatisticsLineitemIcon = () => import('@/assets/images/icons/statistics_line_items.svg')
const SvgStatisticsAccountsIcon = () => import('@/assets/images/icons/statistics_accounts.svg')

export default {
    components: {
        SvgStatisticsGroupIcon,
        SvgStatisticsProductsIcon,
        SvgStatisticsLineitemIcon,
        SvgStatisticsAccountsIcon
    },
    props: ['editMode'],
    setup () {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const breakPoint = computed(() => store.state['app']['windowWidth'])
        const needResponsiveStyle = computed(() => (breakPoint.value > 1200 && breakPoint.value <= 1340) || (breakPoint.value < 1070 && breakPoint.value >= 992))
        const {
            viewType
        } = useDashboardRender()
        const viewTypeIsMobile = computed(() => viewType.value === 'mobile')
        const {
            getSummaryStatistics
        } = useDashboard()
        const currentParams = computed(() => store.getters['$_dashboard/currentParams'])
        const [status, summaryStatisticsData] = getSummaryStatistics(currentParams.value)
        const statistics = computed(() => {
            return [
                {
                    item: 'Accounts',
                    component: 'SvgStatisticsAccountsIcon',
                    variant: 'light-success',
                    num: summaryStatisticsData.value.accounts
                },
                {
                    item: 'Products',
                    component: 'SvgStatisticsProductsIcon',
                    variant: 'light-info',
                    num: summaryStatisticsData.value.products
                },
                {
                    item: 'Line Items',
                    component: 'SvgStatisticsLineitemIcon',
                    variant: 'light-danger',
                    num: summaryStatisticsData.value.lineitems
                }
            ]
        })
        watch(currentParams, (value, oldValue) => {
            getSummaryStatistics(value)
        }, {
            deep: true
        })
        return {
            statistics,
            status,
            needResponsiveStyle,
            viewTypeIsMobile
        }
    }
}
</script>

<style>
.card-grey-b4 {
    color: #959595;
}
.card-grey-95 {
    color: #B4B4B4;
}
.centered-content-statistics {
    position: absolute;
    width: 97%;
    max-width: 571px !important;
    top: 50%;
    transform: translateY(calc(-50% + 15px));
}
</style>
